import { useEffect, useState } from 'react';
import jeejeokImg from '../../assets/img/team/jeejeokImg.jpg';  // 지적측량 이미지
import generalImg from '../../assets/img/team/generalImg.jpg';  // 일반측량 이미지
import tomokImg from '../../assets/img/team/tomokImg.jpg';      // 토목측량 이미지
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import * as zy from '../../common/zeroyear-1.0.0';
let sessionStorage = window.sessionStorage;

export default function Services () {
    const [admin, setAdmin] = useState(false);
    const [data, setData] = useState([]);
    const [editData, setEditData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const selectAll = () => {
       zy.select('selectService', [], (item) => {
            setData(item);
       }); 
    }
    const changeTitle = (event) => {
        setEditData({...editData, SERVICE_TITLE: event.target.value})
    }
    const changeContent = (event) => {
        setEditData({...editData, SERVICE_CONTENT: event.target.value})
    }
    const changeImage = (event) => {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = function (e) {
            setEditData({...editData, SERVICE_IMG: e.target.result})
        }
    }
    const openModal = (event) => { 
        setEditData({...data.find((item) => item.SERVICE_DV === event.target.id), SERVICE_DV: event.target.id});
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };
    const getService = (code) => {
        return data.find((item) => item.SERVICE_DV === code);
    }
    const saveService = () => {
            zy.modify('updateService', [
                editData.SERVICE_TITLE, editData.SERVICE_CONTENT, editData.SERVICE_IMG, editData.SERVICE_DV
            ], (item) => {
                closeModal();
                selectAll();
            });
    }
    useEffect(() => {
        setAdmin(sessionStorage.getItem('isLogin'));
        selectAll();
    }, []);
    return (
        <>
        <section id="services" className="services">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch" data-aos="fade-up">
                        <div className="subjects icon-box">
                            <img src={getService('10')?.SERVICE_IMG} alt=""></img>
                            <h4><a>{getService('10')?.SERVICE_TITLE}</a></h4>
                            <p>{getService('10')?.SERVICE_CONTENT}</p>
                            <a className="online-btn" href="/SurveyEstimate">측량사업부 온라인 견적문의</a>
                            <a className="more-btn" href="/BizzIntroSurvey">READ MORE &gt;</a>
                            {admin ? <button id="10" className="btn-cancel" onClick={openModal}>수정</button> : null}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="150">
                        <div className="subjects icon-box">
                            <img src={getService('20')?.SERVICE_IMG} alt=""></img>
                            <h4><a>{getService('20')?.SERVICE_TITLE}</a></h4>
                            <p>{getService('20')?.SERVICE_CONTENT}</p>
                            <a className="online-btn" href="/SurveyEstimate">측량사업부 온라인 견적문의</a>
                            <a className="more-btn" href="/BizzIntroSurvey">READ MORE &gt;</a>
                            {admin ? <button id="20" className="btn-cancel" onClick={openModal}>수정</button> : null}
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="300">
                        <div className="subjects icon-box">
                            <img src={getService('30')?.SERVICE_IMG} alt=""></img>
                            <h4><a>{getService('30')?.SERVICE_TITLE}</a></h4>
                            <p>{getService('30')?.SERVICE_CONTENT}</p>
                            <a className="online-btn" href="DesignEstimate">설계사업부 온라인 견적문의</a>
                            <a className="more-btn" href="BizzIntroDesign">READ MORE &gt;</a>
                            {admin ? <button id="30" className="btn-cancel" onClick={openModal}>수정</button> : null}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Modal 
        show={showModal}
        onHide={closeModal}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered>
        <Form noValidate>
            <Modal.Header closeButton>
            <Modal.Title>이미지 등록</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="d-input mb-3" controlId="Perf_DV">
                    <Form.Label>제목</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder=""
                        onChange={changeTitle}
                        defaultValue={editData?.SERVICE_TITLE}
                        required/>
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="Perf_DV">
                    <Form.Label>내용</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder=""
                        onChange={changeContent}
                        defaultValue={editData?.SERVICE_CONTENT}
                        required/>
                </Form.Group>
                <Form.Group className="d-input mb-3" controlId="Perf_TITLE">
                    <Form.Label>이미지</Form.Label>
                    <Form.Control
                        type="file"
                        accept="image/gif, image/jpeg, image/png"
                        onChange={changeImage}
                        placeholder=""
                        required/>
                    <Form.Control.Feedback type="invalid">이미지를 선택해주세요.</Form.Control.Feedback>
                </Form.Group>
                <div style={{marginBottom: '15px'}}>
                    <Row xs={2} md={4} className="g-4">
                        <Col>
                            <Card className='perf-card'>
                                <div className="perf-cards">
                                    <Card.Img variant="top" src={editData?.SERVICE_IMG} className="perf-card-img-eidt w-100"/>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Modal.Footer>
                    <button className="btn-cancel" onClick={closeModal}>닫기</button>
                    <button className="btn-normal" type="button" onClick={saveService}>저장</button>
                </Modal.Footer>
            </Modal.Body>
        </Form>
    </Modal>
    </>
    );
}